import { render, staticRenderFns } from "./StatisticsSalesMonth.vue?vue&type=template&id=0f469522&scoped=true&"
import script from "./StatisticsSalesMonth.vue?vue&type=script&lang=js&"
export * from "./StatisticsSalesMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f469522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f469522')) {
      api.createRecord('0f469522', component.options)
    } else {
      api.reload('0f469522', component.options)
    }
    module.hot.accept("./StatisticsSalesMonth.vue?vue&type=template&id=0f469522&scoped=true&", function () {
      api.rerender('0f469522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Dashboard/StatisticsSalesMonth.vue"
export default component.exports